export namespace CompanyConstants {
  export enum Type {
    LEGAL_PERSON = "LEGAL_PERSON",
    PHYSICAL_PERSON = "PHYSICAL_PERSON",
  }

  export enum Acronym {
    LEGAL_PERSON = "PJ",
    PHYSICAL_PERSON = "PF",
  }

  export enum Document {
    LEGAL_PERSON = "CNPJ",
    PHYSICAL_PERSON = "CPF",
  }

  export enum Status {
    ACTIVE = "ACTIVE",
    DISABLED = "DISABLED",
  }
}
